(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initHeader(scope = document) {
    const header = scope.querySelector('[data-site-header]') || document.querySelector('[data-site-header]');
    if (!header || header.dataset.bound === 'true') return;
    header.dataset.bound = 'true';
    const toggle = header.querySelector('.nav-toggle');
    const nav = header.querySelector('.main-nav');
    const parents = [...header.querySelectorAll('.nav-item.has-children')];
    const closeAll = (except) => parents.forEach((item) => {
      if (item === except) return;
      item.classList.remove('is-open');
      item.querySelector(':scope > a')?.setAttribute('aria-expanded', 'false');
    });
    if (toggle && nav) toggle.addEventListener('click', () => {
      const open = toggle.getAttribute('aria-expanded') !== 'true';
      toggle.setAttribute('aria-expanded', String(open));
      nav.classList.toggle('is-open', open);
      if (!open) closeAll();
    });
    parents.forEach((item) => {
      const link = item.querySelector(':scope > a');
      link?.addEventListener('click', (event) => {
        if (window.innerWidth > 1100) return;
        if (!item.classList.contains('is-open')) event.preventDefault();
        const open = !item.classList.contains('is-open');
        closeAll(item);
        item.classList.toggle('is-open', open);
        link.setAttribute('aria-expanded', String(open));
      });
    });
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      closeAll();
      nav?.classList.remove('is-open');
      toggle?.setAttribute('aria-expanded', 'false');
    });
    document.addEventListener('click', (event) => {
      if (header.contains(event.target)) return;
      closeAll();
      nav?.classList.remove('is-open');
      toggle?.setAttribute('aria-expanded', 'false');
    });
  }

  function initScenes(scope = document) {
    scope.querySelectorAll('[data-pawpace-scene]').forEach((scene) => {
      if (scene.dataset.sceneBound === 'true' || reduceMotion.matches) return;
      scene.dataset.sceneBound = 'true';
      const layers = [...scene.querySelectorAll('[data-depth]')];
      const strength = Number(scene.dataset.strength || 8);
      let frame;
      const reset = () => layers.forEach((layer) => { layer.style.transform = ''; });
      scene.addEventListener('pointermove', (event) => {
        if (event.pointerType === 'touch') return;
        const rect = scene.getBoundingClientRect();
        const x = (event.clientX - rect.left) / rect.width - .5;
        const y = (event.clientY - rect.top) / rect.height - .5;
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => layers.forEach((layer) => {
          const depth = Number(layer.dataset.depth || 1);
          layer.style.transform = `translate3d(${x * strength * depth}px, ${y * strength * depth}px, ${Math.abs(depth) * 2}px) rotateX(${-y * depth}deg) rotateY(${x * depth}deg)`;
        }));
      });
      scene.addEventListener('pointerleave', reset);
    });
  }

  function initGalleries(scope = document) {
    scope.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
      if (gallery.dataset.galleryBound === 'true') return;
      gallery.dataset.galleryBound = 'true';
      const items = [...gallery.querySelectorAll('[data-media-index]')];
      const thumbs = [...gallery.querySelectorAll('[data-media-target]')];
      const counter = gallery.querySelector('[data-media-current]');
      const activate = (index) => {
        items.forEach((item, i) => {
          const active = i === index;
          item.hidden = !active;
          item.classList.toggle('is-active', active);
        });
        thumbs.forEach((thumb, i) => {
          const active = i === index;
          thumb.classList.toggle('is-active', active);
          thumb.setAttribute('aria-selected', String(active));
          if (active) thumb.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'nearest', inline: 'nearest' });
        });
        if (counter) counter.textContent = String(index + 1);
      };
      thumbs.forEach((thumb, i) => {
        thumb.addEventListener('click', () => activate(i));
        thumb.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          let next = i;
          if (event.key === 'ArrowLeft') next = Math.max(0, i - 1);
          if (event.key === 'ArrowRight') next = Math.min(thumbs.length - 1, i + 1);
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = thumbs.length - 1;
          activate(next); thumbs[next].focus();
        });
      });
    });
  }

  function initVariants(scope = document) {
    scope.querySelectorAll('[data-product-root]').forEach((root) => {
      const select = root.querySelector('[data-variant-select]');
      const price = root.querySelector('[data-product-price]');
      if (!select || select.dataset.variantBound === 'true') return;
      select.dataset.variantBound = 'true';
      select.addEventListener('change', () => {
        const option = select.options[select.selectedIndex];
        if (price && option.dataset.price) price.textContent = option.dataset.price;
        const url = new URL(window.location.href);
        url.searchParams.set('variant', select.value);
        history.replaceState({}, '', url);
      });
    });
  }

  function init(scope = document) {
    initHeader(scope);
    initScenes(scope);
    initGalleries(scope);
    initVariants(scope);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
